import { SxProps } from '@mui/material';
import theme from 'themes/theme';

export const ExpandedRowCellHeaderTextSx: SxProps = {
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '24px',
  color: '#60605D',
};

export const ExpandableRowCellDetailTextSx: SxProps = {
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '1.43',
};

export const ExpandableRowCellTrackingLinkSx: SxProps = {
  ...ExpandableRowCellDetailTextSx,
  textDecoration: 'underline',
  textDecorationColor: '#13141480',
  fontWeight: 600,
  color: '#131414'
}

export const OrderItemTableSx: SxProps = {
  '& .MuiTableCell-root': {
    padding: '16px',
  },
  '& .MuiTableHead-root .MuiTableCell-root': {
    padding: '12px 16px 0px 16px',
    whiteSpace: 'nowrap',
  },
  '& .MuiTableBody-root .MuiTableCell-root': {
    borderBottom: 'none',
  },
  '& .MuiTableCell-root:first-of-type': {
    paddingLeft: 0,
  },
  '& .MuiTableCell-root:last-of-type': {
    paddingRight: 0,
  },
  '& .MuiTableBody-root .MuiTableCell-root:nth-of-type(6), & .MuiTableBody-root .MuiTableCell-root:nth-of-type(7)': {
    width: 'min-content',
    '& .MuiChip-root': {
      width: 'fit-content',
    },
    '& .MuiStack-root': {
      width: 'fit-content',
    },
  },
};

export const ExpandableProductTitleRowCellTextSx: SxProps = {
  ...ExpandableRowCellDetailTextSx,
  width: '275px',
  maxWidth: '275px',
};

export const ExpandedTableRowSx: SxProps = {
  '&.MuiTableRow-root': {
    verticalAlign: 'baseline',
  },
};

export const ShipmentPillSx: SxProps = {
  height: '24px',
  maxWidth: '165px',
  display: 'inline-flex',
};

export const FailedPillTypeSx: SxProps = {
  color: theme.palette.colors.gray60,
  fontFamily: 'Inter',
  fontSize: '10px',
  fontWeight: 500,
  lineHeight: '14px',
  maxWidth: '140px',
  pt: '2px',
};

export const ExpandedContainerSx: SxProps = {
  maxWidth: '100% !important',
  '& .MuiTable-root': {
    width: 'auto',
    minWidth: '1280px',
  },
};

export const ShipmentStatusDescriptionSx: SxProps = {
  width: '190px',
  height: 'auto',
  fontWeight: '500',
  fontSize: '12px',
  lineHeight: '12px',
  color: theme.palette.colors.gray60,
  marginTop: '8px',
};
